import { configureStore } from '@reduxjs/toolkit'

import { apartmentsSlice } from './modules/ApartmentsList';
import { filterSlice } from './modules/Filters';
import { visualSlice } from './modules/VisualStep';

export const store = configureStore({
  reducer: {
		apartments: apartmentsSlice,
		filters: filterSlice,
		visual: visualSlice,
	},
  devTools: true,
});
